import { render, staticRenderFns } from "./statusPeriodoTransportes.vue?vue&type=template&id=20d2a91e&"
import script from "./statusPeriodoTransportes.vue?vue&type=script&lang=js&"
export * from "./statusPeriodoTransportes.vue?vue&type=script&lang=js&"
import style0 from "./statusPeriodoTransportes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports